module.exports = __webpack_public_path__ + "img/colorBox2.d06e148e.jpg";